module.exports = __webpack_public_path__ + "static/img/tires-bg.fff00ab.jpg";